import React, { useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import MDialog from "components/Shared/MDialog.tsx";
import { MSpinner } from "components/Shared";
import { Button } from "react-md";
import { unassignCasesToUnderwriter } from "requests/underwriter";
import { updateQuickListInPlace } from "actions/homeowner/quickList";
import responseHandler from "responseHandler";

const createQuicklistUpdate = (quickListId, controlNumbers) => {
  const update = [];
  controlNumbers.forEach(c => {
    update.push({
      controlIDNumber: c,
      underwriterCode: ""
    });
  });
  return {
    id: quickListId,
    key: "controlIDNumber",
    update
  };
};

const UnderwriterUnassign = ({
  visible,
  hideDialog,
  controlNumbers,
  makeToast,
  selectedQuickListId,
  updateQuickList
}) => {
  const [isUnassigning, setIsUnassigning] = useState(false);
  const mounted = useRef(true);

  useEffect(() => {
    return (() => { mounted.current = false; });
  }, []);

  const unassignCallback = () => {
    makeToast("Policies unassigned.", "success");
    finishAssigning();
  };

  const finishAssigning = () => {
    hideDialog();
    setIsUnassigning(false);
  };

  const onUnassign = () => {
    setIsUnassigning(true);
    const payload = { controlIdNumbers: controlNumbers };
    unassignCasesToUnderwriter(payload, unassignCallback, finishAssigning, mounted);
    const update = createQuicklistUpdate(selectedQuickListId, controlNumbers);
    updateQuickList(update);
  };

  const getContentActions = () => {
    if (isUnassigning) return [];
    const actions = [
      <Button key="cancelUnassignUnderwriter" raised onClick={hideDialog} >Cancel</Button>
    ];
    if (controlNumbers.length > 0) {
      actions.unshift(<Button key="unassignUnderwriter" primary raised onClick={onUnassign} >Unassign</Button>);
    }
    return actions;
  };

  return (
    <MDialog
      id="unassign-underwriter-dialog"
      className="unassign-underwriter-dialog"
      title="Unassign Policies"
      contentClassName="unassign-underwriter-dialog-content"
      visible={visible}
      contentActions={getContentActions()}
    >
      {isUnassigning && <MSpinner />}
      {controlNumbers.length === 0 && !isUnassigning && <p>No policies selected. Please use the checkboxes to select policies to assign.</p>}
      {controlNumbers.length > 0 &&
        <p>Are you sure you want to unassign {`${controlNumbers && controlNumbers.length} ${controlNumbers.length > 1 ? "policies" : "policy"}`}?</p>}
    </MDialog>
  );
};

UnderwriterUnassign.propTypes = {
  visible: PropTypes.bool.isRequired, // Show/hide the dialog
  hideDialog: PropTypes.func.isRequired, // Function to be called to set visibility to false
  controlNumbers: PropTypes.arrayOf(PropTypes.number).isRequired,  // Array of control numbers to be assigned
  selectedQuickListId: PropTypes.number,  // Id of the selected quick, used to update data
  // From dispatch
  makeToast: PropTypes.func.isRequired,
  updateQuickList: PropTypes.func.isRequired,
};

UnderwriterUnassign.defaultProps = {
  controlNumbers: [],
  visible: false,
};

const mapDispatchToProps = dispatch => ({
  makeToast(text, type) {
    responseHandler.customToast(text, type, dispatch);
  },
  updateQuickList(update) {
    dispatch(updateQuickListInPlace(update));
  },
});

export default connect(null, mapDispatchToProps)(UnderwriterUnassign);